import { StyleSheet } from 'aphrodite';

export const AppTheme = {
  primaryColor: '#8dc73f',
  primaryColorVariant: '#ef3e79',
  secondaryColor: '#ffffff',
  borderColor: '#707070',
  primaryBg: 'whitesmoke',
  secondaryBg: 'white',
  buttonBg: '#8dc73f',
  buttonTextColor: '#000000',
  pagePadding: 5,
  viewPort: 1200,
  toolbarHeight: 80,
}

export const AppStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.primaryBg,
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.primaryBg,
    maxWidth: 1200,
    '@media (max-width: 767px)': {
      margin: '0px 12px'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      margin: '0px 12px'
    },
  },
  containerContentCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    maxWidth: 1200,
    '@media (max-width: 767px)': {
      margin: '0px 12px'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      margin: '0px 12px'
    },
  },
  entityContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 100,
    width: '100%',
  },
  entityTableLinkIcon: {
    padding: 3,
    fontSize: 28,
    color: 'black',
    cursor: 'pointer'
  },
  pageTitle: {
    fontSize: 32,
    paddingBottom: 24
  },
  pageSubTitle: {
    fontSize: 16,
    paddingBottom: 5
  }
});



// WEBPACK FOOTER //
// ./src/styles/AppTheme.js